import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Container, Typography } from "@mui/material";
import FullscreenToggle from "../../../custom-components/FullScreenToggle";
import { ReactComponent as AutomateIcon } from "../../../../images/automateIcon.svg";
import ConstructionPhaseComponent from "../../../input-components/security-testing/ConstructionPhase";
import SASTScanDashboard from "../../../output-components/security-testing/SASTDashboard";
import { SecurityFlowDataContext } from "../../SecurityTestingPage";

const ConstructionPhaseOutputPage = () => {
  const location = useLocation();

  const [scanResults, setScanResults] = useState(
    () => location.state?.scanResults || []
  );

  const { setConstructionPhase } = useContext(SecurityFlowDataContext);

  const [dateTime, setDateTime] = useState(location.state?.date || "");
  const [runType, setRunType] = useState(location.state?.runType || "");

  const [codeSummary, setCodeSummary] = useState(
    location.state?.codeSummary || {}
  );
  // const [SASTOWASPResponse, setSASTOWASPResponse] = useState(
  //   location.state?.owaspResults || []
  // );

  useEffect(() => {
    const results = location.state?.scanResults || [];
    const date = location.state?.date || "";
    setConstructionPhase(location.state?.scanResults);
    // setSASTOWASPResponse(location.state?.owaspResults || []);
    setCodeSummary(location.state?.codeSummary || {});
    setRunType(location.state?.runType || "");
    setScanResults(results);
    setDateTime(date);
  }, [location.state]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%", // Always full width
        minHeight: "80vh", // Fill vertical space
        bgcolor: "#f6f3f2",
        overflowY: "auto", // Allow scrolling if needed
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
        px: { xs: 2, sm: 3, md: 4 }, // Responsive side padding
        boxSizing: "border-box",
      }}
    >
      <Container
        sx={{
          width: "100%", // Full width inside parent
          maxWidth: "100%", // Never overflow
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // Center content horizontally
          "& > *:not(:last-child)": {
            mb: 2, // Add vertical gap between sections
          },
          mb: 6,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center">
            <AutomateIcon style={{ marginRight: 4 }} />
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ mt: 0.5 }}
            >
              Generate fast and automated security checks
            </Typography>
          </Box>
          <FullscreenToggle />
        </Box>

        <ConstructionPhaseComponent />

        {Array.isArray(scanResults) && scanResults.length > 0 && (
          <SASTScanDashboard
            runType={runType}
            sastScanResult={scanResults}
            scanDate={dateTime}
            codeSummary={codeSummary}
            // owaspResults={SASTOWASPResponse}
          />
        )}
      </Container>

      {/* Sticky footer */}
      <Box
        component="footer"
        sx={{
          width: "100%",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          px: 2,
          py: 1,
          position: "fixed",
          bottom: 0,
          zIndex: 99,
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
    </Box>
  );
};

export default ConstructionPhaseOutputPage;
